<template>
  <div class="yhc-service-level-rank-fees">
    <!-- デスクトップ表示: 横長表記（各ランクをセルで区分け） -->
    <table
      class="yhc-service-level-rank-fees__table yhc-service-level-rank-fees__table--horizontal"
    >
      <tbody>
        <tr>
          <th scope="row">ランク</th>
          <td
            v-for="item in prices"
            :key="`rank-${item.rank}`"
            class="yhc-service-level-rank-fees__cell"
          >
            {{ item.rank }}
          </td>
        </tr>
        <tr>
          <th scope="row">サイズ（三辺合計）</th>
          <td
            v-for="item in prices"
            :key="`size-${item.rank}`"
            class="yhc-service-level-rank-fees__cell"
          >
            {{ item.sizeLabel }}
          </td>
        </tr>
        <tr>
          <th scope="row">料金（税込）</th>
          <td
            v-for="item in prices"
            :key="`price-${item.rank}`"
            class="yhc-service-level-rank-fees__cell"
          >
            {{ item.priceText }}
          </td>
        </tr>
        <tr v-if="shouldShowNotaxPrices">
          <th scope="row">料金（税抜）</th>
          <td
            v-for="item in prices"
            :key="`price-notax-${item.rank}`"
            class="yhc-service-level-rank-fees__cell"
          >
            {{ item.priceNotaxText }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- スマホ表示: 縦型テーブル（元の形式） -->
    <table
      class="yhc-service-level-rank-fees__table yhc-service-level-rank-fees__table--vertical"
    >
      <thead>
        <tr>
          <th scope="col">ランク</th>
          <th scope="col">
            <span class="header-main">サイズ</span>
            <span class="header-sub">（三辺合計）</span>
          </th>
          <th scope="col">
            <span class="header-main">料金</span>
            <span class="header-sub">（税込）</span>
          </th>
          <th
            v-if="shouldShowNotaxPrices"
            scope="col"
          >
            <span class="header-main">料金</span>
            <span class="header-sub">（税抜）</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in prices"
          :key="item.rank"
        >
          <td data-label="ランク">
            {{ item.rank }}
          </td>
          <td data-label="サイズ（三辺合計）">
            {{ item.sizeLabel }}
          </td>
          <td data-label="料金（税込）">
            {{ item.priceText }}
          </td>
          <td
            v-if="shouldShowNotaxPrices"
            data-label="料金（税抜）"
          >
            {{ item.priceNotaxText }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export type SizeRankPriceItem = {
  rank: string
  sizeLabel: string
  price: number
  priceText: string
  priceNotax: number
  priceNotaxText: string
}

export default defineComponent({
  name: 'YhcServiceLevelRankFees',
  props: {
    prices: {
      type: Array as PropType<SizeRankPriceItem[]>,
      default: () => [],
    },
  },
  computed: {
    shouldShowNotaxPrices(): boolean {
      if (!this.prices || this.prices.length === 0) {
        return false
      }
      return this.prices.every((item) => {
        return typeof item.priceNotax === 'number' && item.priceNotax > 0
      })
    },
  },
})
</script>

<style lang="scss" scoped>
.yhc-service-level-rank-fees {
  width: 100%;
  margin-top: 0.75rem;

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.95rem;

    th,
    td {
      border: 1px solid #d9e2ef;
      padding: 0.3rem 0.2rem;
    }
  }

  // デスクトップ表示: 横長表記
  &__table--horizontal {
    th {
      background-color: rgba(0, 102, 179, 0.08);
      color: #1a3d6d;
      font-weight: 700;
      text-align: left;
      width: 100px;
      min-width: 100px;
      vertical-align: top;
    }

    td {
      background-color: #ffffff;
      font-weight: 600;
      text-align: center;
      vertical-align: top;
    }

    // スマホ表示時は非表示
    @media (max-width: 767px) {
      display: none;
    }
  }

  // スマホ表示: 縦型テーブル
  &__table--vertical {
    // デスクトップ表示時は非表示
    display: none;

    @media (max-width: 767px) {
      display: table;
      font-size: 0.875rem;

      th,
      td {
        padding: 0.3rem 0.2rem;
        text-align: center;
      }

      th {
        background-color: rgba(0, 102, 179, 0.08);
        color: #1a3d6d;
        font-weight: 700;

        .header-main {
          display: block;
          line-height: 1.2;
        }

        .header-sub {
          display: block;
          font-size: 0.85em;
          line-height: 1.2;
        }
      }

      td {
        background-color: #ffffff;
        font-weight: 600;
      }
    }
  }

  &__cell {
    min-width: 60px;
  }
}
</style>
